import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do independent auto shops compete with dealerships?",
    "a": "Trust and price transparency — neither of which dealerships do well online. Real technician bios, ASE certs, real shop photos, and review velocity beat dealership polish every time."
  },
  {
    "q": "Is SEO worth it for an auto repair shop?",
    "a": "Yes — 'mechanic near me', 'brake repair', and 'check engine light' are huge, intent-heavy searches. Ranking captures customers at the panic moment."
  },
  {
    "q": "Should auto shops run Google Ads?",
    "a": "For high-ticket services — transmission, suspension, full detail — yes. For oil changes, SEO and GBP carry it."
  },
  {
    "q": "What about detailing and ceramic coating?",
    "a": "Massive opportunity — high-margin and underserved on search. We build dedicated detail and coating pages that convert at premium price points."
  },
  {
    "q": "Do you market specialty shops (Euro, diesel, performance)?",
    "a": "Yes — specialty shops outperform generic ones online when you build for the niche. Euro, diesel, JDM, and performance pages each get tailored SEO."
  }
];

export const Route = createFileRoute("/auto-repair-marketing-colorado")({
  head: () =>
    industryMarketingHead("Auto Repair", "auto repair or detailing shop", "auto-repair-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Auto Repair"}
      industryLower={"auto repair or detailing shop"}
      slug={"auto-repair-marketing-colorado"}
      subheadline={"We help Colorado independent auto repair, detailing, and specialty shops fill the bays without paying a dealership for leads."}
      painPoints={["Customers go to dealerships because they don't know you exist","Your site shows hours and a phone number — and not much else","You can't predict next week's bay schedule"]}
      serviceDescriptions={{
        seo: "Rank for brake repair, transmission, oil change, detailing, and every service in every Colorado market.",
        googleMaps: "Own 'auto repair near me' in the Map Pack so customers call you instead of the dealer.",
        webDesign: "Trust-first sites with technician bios, ASE certs, online booking, and real shop photos.",
        ppc: "Profitable Google Ads tuned to high-margin brake, suspension, and transmission searches.",
        geoAi: "Get cited when drivers ask ChatGPT 'best mechanic in Colorado Springs' or 'auto detailer near me'.",
        socialMedia: "Shop content that builds trust and converts the 'should I take it to the dealer' decision in your favor.",
      }}
      testimonial={{"quote":"Bays are booked two weeks out and dealership comparisons stopped killing our quotes. The reviews flywheel changed everything.","role":"Independent Shop Owner","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Auto repair marketing in Colorado Springs","description":"Compete with dealerships across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Auto repair marketing in Denver","description":"Build a steady bay schedule in Denver's competitive auto market."},{"to":"/boulder-digital-marketing","label":"Auto repair marketing in Boulder","description":"Specialty and Euro repair for Boulder's car-savvy customer base."}]}
    />
  ),
});
